import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NewsService } from '@common/services/news.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'fina-news-view',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './news-view.component.html',
    styleUrls: ['news-view.component.scss'],
})
export class NewsViewComponent {
    constructor(public newsService: NewsService, private readonly activeModal: NgbActiveModal) {}

    close() {
        this.activeModal.close(1);
        this.newsService.onHideModal();
    }
}
